import outdent from "outdent";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { statusSelectors } from "../../base/selectors";

const buildVersionString = (apiVersion, snapVersion, snapRevision) =>
  outdent({ newline: "" })`
     ${apiVersion ? `API version: ${apiVersion}` : ``}
     ${snapVersion ? `, Snap version: ${snapVersion} (rev${snapRevision})` : ``}
    `;

const Footer = ({ apiVersion, snapVersion, snapRevision, children }) => (
  <div className="l-settings__footer">
    <span>
      <small id="version">
        {buildVersionString(apiVersion, snapVersion, snapRevision)}
      </small>
    </span>
    <div>{children}</div>
  </div>
);

Footer.propTypes = {
  children: PropTypes.node.isRequired,
  apiVersion: PropTypes.string.isRequired,
  snapVersion: PropTypes.string,
  snapRevision: PropTypes.string
};

Footer.defaultProps = {
  snapVersion: undefined,
  snapRevision: undefined
};

const mapStateToProps = state => ({
  apiVersion: statusSelectors.app.version(state),
  snapVersion: statusSelectors.snap.version(state),
  snapRevision: statusSelectors.snap.revision(state)
});

export default connect(mapStateToProps)(Footer);
